import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import AttendanceShiftUtils from 'modules/attendance/lib/utils/AttendanceShift'

interface Props {
  timeSheetData: ReturnType<typeof useTimesheetData>
}

const WorkingLocation = ({ timeSheetData }: Props) => {
  const { shifts } = timeSheetData

  const locationTypesWithPercentage = AttendanceShiftUtils.totalMinutesPerLocationPercentage(shifts)
  const sortedEntries = Object.entries(locationTypesWithPercentage).sort(
    ([, aPercentage], [, bPercentage]) => parseFloat(bPercentage) - parseFloat(aPercentage)
  )
  return (
    <Box gap="s8" paddingY="s12">
      <Text size="300" weight="medium">
        {i18n.t('clock_in.sidepanel.clocked.work_location.title')}
      </Text>

      <Box
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        background="grey200"
        padding="s16"
      >
        <Box gap="s8">
          {sortedEntries.map(([label, percentage]) => (
            <Box key={label} justifyContent="spaceBetween" flexDirection="row" gap="s8">
              <Text size="200">{label}</Text>
              <Text size="200" weight="medium">
                {percentage}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
export default WorkingLocation
